import { PhoneNumberUtil } from 'google-libphonenumber'
import { COUNTRIES } from 'constants/countries'

const phoneUtil = PhoneNumberUtil.getInstance()
const regionNames =
  typeof Intl !== 'undefined' && Intl.DisplayNames ? new Intl.DisplayNames(['en'], { type: 'region' }) : null

const findRegionCode = (countryName: string): string | undefined => {
  const name = countryName.trim().toLowerCase()

  return Object.keys(COUNTRIES).find(
    (code) => COUNTRIES[code].toLowerCase() === name || regionNames?.of(code)?.toLowerCase() === name
  )
}

const DEFAULT_COUNTRY = 'Australia'

const buildExample = (countryName: string): string | undefined => {
  const region = findRegionCode(countryName)
  const countryCode = region ? phoneUtil.getCountryCodeForRegion(region) : 0

  return countryCode ? `+${countryCode} 0000 0000` : undefined
}

// Example number in international format for the given country name (e.g. 'Ukraine' -> '+380 0000 0000').
// Falls back to Australia when the country is missing or unknown.
export const getPhoneExample = (countryName?: string | null): string =>
  (countryName && buildExample(countryName)) || (buildExample(DEFAULT_COUNTRY) as string)
